import { withCompController } from '@wix/editor-elements-integrations';
import { mapConsentPolicyStateRefValues } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/viewer/utils';
import type {
  HtmlComponentMapperProps,
  HtmlComponentProps,
  HtmlComponentStateRefs,
  HtmlComponentControllerProps,
} from '../HtmlComponent.types';
import type { ConsentPolicyControllerProps } from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/ConsentPolicyWrapper.types';

export const innerControllerFunction = ({
  stateValues,
  mapperProps,
}: {
  stateValues: HtmlComponentStateRefs;
  mapperProps: HtmlComponentMapperProps;
}): ConsentPolicyControllerProps & HtmlComponentMapperProps => ({
  ...mapperProps,
  ...mapConsentPolicyStateRefValues(stateValues),
});

export default withCompController<
  HtmlComponentMapperProps,
  HtmlComponentControllerProps,
  HtmlComponentProps,
  HtmlComponentStateRefs
>(innerControllerFunction);
